import { useModalsDataActions } from '../../../../../hooks/useModalsDataActions';
import useServiceData from '../../../../../hooks/useServiceData';
import getServiceDataKey from '../../utils/getServiceDataKey';
import getCenterFromBounding from '../../utils/getCenterFromBounding';
import { clamp } from 'lodash';
import createInteractiveShopModal from '../../utils/createInteractiveShopModal';
import content from '../../constants/content';
import { useInteractiveShop } from '../../../../../providers/onboarding-provider/models/hooks/useInteractiveShop';
import { useOnboardingConditions } from '../../../../../providers/onboarding-provider/models/hooks/useOnboardingConditions';

const { onboardingModals } = content;

export default function useInteractiveShopModals({
  bounding,
  animatedDrag,
  offsetData,
  highlightData: [, setHighlightedItem],
}) {
  const { addModal } = useModalsDataActions();
  const { get, save } = useServiceData();
  const { updateOnboarding } = useInteractiveShop();
  const { shouldShowOnboardingStep } = useOnboardingConditions();

  const openModal = (item) => {
    const { action, button } = item;

    const modalProps = createInteractiveShopModal({
      ...onboardingModals[action],
      button,
      onClick() {
        setHighlightedItem(null);

        if (shouldShowOnboardingStep(action)) {
          updateOnboarding(action);
        }
      },
    });
    addModal(modalProps);

    const key = getServiceDataKey(action);
    const modalsData = get('modalsData') ?? {};
    save('modalsData', { ...modalsData, [key]: true });
  };

  return (e, item, onAnimated = () => openModal(item)) => {
    const { target } = e;
    const elementBounding = target.getBoundingClientRect();
    const position = getCenterFromBounding(elementBounding);
    const { position: normalizedTargetPosition } = onboardingModals[item.action];
    const targetPosition = {
      x: global.innerWidth * normalizedTargetPosition.x,
      y: global.innerHeight * normalizedTargetPosition.y,
    };
    const offset = {
      x: targetPosition.x - position.x,
      y: targetPosition.y - position.y,
    };
    const {
      x: { min: minX, max: maxX },
      y: { min: minY, max: maxY },
    } = bounding;
    const { x, y } = offsetData.current;
    animatedDrag(clamp(x + offset.x, minX, maxX), clamp(y + offset.y, minY, maxY), false, ({ cancelled, finished }) => {
      if (!cancelled && finished) onAnimated();
    });
    setHighlightedItem(item.action);
  };
}
